'use client';

import { QueryClientProvider } from '@tanstack/react-query';
import NextTopLoader from 'nextjs-toploader';
import { ReactNode } from 'react';
import { ToastContainer } from 'react-toastify';

import AuthProvider from '@/components/elements/AuthProvider';
import AuthInitializer from '@/components/elements/AuthProvider/AuthInitializer';
import LoginDrawer from '@/components/elements/LoginDrawer';
import PopupTemplate from '@/components/elements/PopupTemplate';
import Main from '@/components/elements/Providers/Main';
import { Sidebar } from '@/components/elements/Sidebar';
import { SidebarProvider } from '@/components/elements/Sidebar/sidebar-provider';
import queryClient from '@/utils/query-client';

function Providers({ children }: { children: ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthInitializer />
      <AuthProvider>
        <SidebarProvider>
          <>
            <NextTopLoader
              color="#84cfff"
              height={4}
              showSpinner={false}
              crawl={true}
              crawlSpeed={200}
              initialPosition={0.2}
              zIndex={9999}
              shadow="0 0 10px #5B8DEF, 0 0 5px #5B8DEF"
            />
            <Sidebar />
            <Main>{children}</Main>
            <LoginDrawer />
          </>
          <ToastContainer />
          <PopupTemplate />
        </SidebarProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default Providers;
